import React, { Component } from "react";

const features = [
  {
    icon: require("./categories.svg"),
    text:
      "Auto Führerschein (Klasse B), Motorrad Führerschein (Klasse A, A1, A2, AM und Mofa), Bus und LKW Führerschein (Klasse C, C1, CE, D, D1, L,T)"
  },
  {
    icon: require("./official.svg"),
    text: "Die sicherste Vorbereitung auf die Prüfung zum Führerschein."
  },
  {
    icon: require("./videos.svg"),
    text:
      "AKTUELLSTER AMTLICHER KATALOG INKL: VIDEOS - inkl. Updates vom 1.4.2017 und 1.10.2017"
  }
];

class Features extends Component {
  render() {
    return (
      <div className="features-container">
        {features.map((f, i) => {
          return (
            <div key={i} className="feature">
              <img src={f.icon} />
              <p>{f.text}</p>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Features;



// WEBPACK FOOTER //
// ./src/components/features.js